import { atomFamily } from 'recoil'

import { getRandomInitialPrice } from 'lib/utils/simulation'

export const prices = atomFamily<number, string>({
  key: 'prices',
  default: getRandomInitialPrice,
})
